<template>
  <TypeOfHeatingFormField :choices="choices" v-on="$listeners" />
</template>

<script>
import { Selectable } from 'chimera/all/components/models/Selectable'
import TSelectableWithTextField from 'chimera/all/components/elements/TSelectableWithTextField.vue'
import TypeOfHeatingFormField from 'chimera/all/components/form/fields/typeOfHeating/TypeOfHeatingFormField.vue'

export default {
  name: 'TypeOfHeatingFormPart',

  components: {
    TypeOfHeatingFormField,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      choices: [
        new Selectable(
          this.$i18n.t('field.type-of-heating.options.floor-heating'),
          this.$i18n.t('field.type-of-heating.options.floor-heating'),
          this.$i18n.t('field.type-of-heating.options.floor-heating'),
        ),
        new Selectable(
          this.$i18n.t(
            'field.type-of-heating.options.floor-heating-and-radiators',
          ),
          this.$i18n.t(
            'field.type-of-heating.options.floor-heating-and-radiators',
          ),
          this.$i18n.t(
            'field.type-of-heating.options.floor-heating-and-radiators',
          ),
        ),
        new Selectable(
          this.$i18n.t('field.type-of-heating.options.radiators'),
          this.$i18n.t('field.type-of-heating.options.radiators'),
          this.$i18n.t('field.type-of-heating.options.radiators'),
        ),
        new Selectable(
          this.$i18n.t('global.other'),
          '',
          this.$i18n.t('global.other'),
          {
            component: TSelectableWithTextField,
            textField: {
              placeholder: this.$i18n.t('global.other'),
            },
          },
        ),
      ],
    }
  },
}
</script>
